/**
 * Advanced Audio Equalizer — Plasmo-built audio equalizer
 *
 * A single web-accessible-resource entry exposes `*` (everything) to
 * `<all_urls>` with no `use_dynamic_url`. Its icons and scripts carry rotating
 * Plasmo build hashes, so the stable probes are the un-hashed HTML/locale files:
 * `popup.html`, `tabs/configure.html` and `_locales/en/messages.json`. Each is
 * fetchable from any page at a fixed URL — served only if the extension is
 * installed, with the ID in the URL.
 *
 * Manifest verified against version 1.0.6.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ibefjagfpcdefiapiapnhleogifimklb';

export const advancedAudioEqualizer: ExtensionDefinition = {
  id: ID,
  name: 'Advanced Audio Equalizer',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 20_000,
  notes:
    'Exposes * to every origin with no dynamic URL. Icons are Plasmo-hashed, so we probe ' +
    'the stable un-hashed popup.html / configure.html / locale files. Conclusive.',
  signals: [
    {
      id: 'war-popup-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch popup.html — a stable, un-hashed entry point exposed to every origin at a ' +
        'fixed URL.',
      weight: 1,
      run: () => probeFetch(ID, 'popup.html'),
    },
    {
      id: 'war-configure-html',
      kind: 'web-accessible-resource',
      description: 'Fetch tabs/configure.html — a second stable un-hashed path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'tabs/configure.html'),
    },
    {
      id: 'war-locale-messages',
      kind: 'web-accessible-resource',
      description:
        'Fetch _locales/en/messages.json — a third stable path, independent of the HTML ' +
        'entry points.',
      weight: 0.5,
      run: () => probeFetch(ID, '_locales/en/messages.json'),
    },
  ],
};
